export default {
  type: `[API] Request Message Banner`,
  url: `/messagebanner/getall`,
  APIMethod: 'GET',
};
